export const EMPTY_PEER_FEEDBACK_LIST_TEXT =
  "There is no Peer Feedback at the moment. Please come back at a later time.";
export const NO_SEARCH_RESULT_TEXT =
  "No search result found. Please consider changing your search term.";
export const ERROR_GENERATE_REPORT =
  "Something went wrong while generating report. Please try again.";

export const ERROR_REQUIRED_QUESTION = "This is a required question";
